import { flash } from "@xola/ui-kit";
import React from "react";
import { useQueryClient } from "react-query";
import { useHistory, useParams } from "react-router-dom";
import { storeUriUi } from "../../../api/storeUriUi";
import { useAccountStore } from "../../../stores/accountStore";
import { AppIFrame, Message } from "../../AppIFrame";

interface AppStoreProps {
    height: string | number;
    route?: string;
}

// Elrond gives us fragments that map to V1's URL hashes. We can't use the V1 URL scheme so this is a temporary map
// that maps from V1 hashes to V2 routes
const fragmentRouteMap: { [key: string]: string } = {
    guides: "/resources/guides",
    packages: "/products/packages",
};

export const AppStore = ({ height, route = "" }: AppStoreProps) => {
    const history = useHistory();
    const queryClient = useQueryClient();
    const { seller: sellerId } = useAccountStore();
    const { appId } = useParams<{ appId?: string }>();

    const handleMessage = ({ event, data }: Message) => {
        switch (event) {
            case "success":
                flash.success(data.message);
                break;

            case "error":
                flash.danger(data?.message ?? "Error installing plugin");
                break;

            case "installation.create":
            case "installation.delete":
                // Update list of roles and installations so the authorization sections may update
                queryClient.refetchQueries(["sellers", sellerId]);
                queryClient.refetchQueries("installations");
                break;

            case "installation.update":
                flash.success("Plugin updated successfully");
                break;

            case "navigate":
                if (!data.options || data.options?.trigger) {
                    // Options is specified with trigger === true OR there are no options
                    const fragment = fragmentRouteMap[data.fragment] ?? `/${data.fragment}`;
                    console.log(
                        `%cNavigating to fragment "${fragment}" -- It may or may not have been implemented`,
                        "color:red",
                    );
                    history.push(fragment);
                }

                break;
            default:
            // intentionally left empty
        }
    };

    const baseUrl = storeUriUi;
    let path = route && appId ? `${route}/${appId}` : route;
    if (appId && !route) {
        path = `/apps/${appId}`;
    }

    const params = `seller=${sellerId}&version=x2`;

    return <AppIFrame url={`${baseUrl}#${path}?${params}`} height={height} onMessage={handleMessage} />;
};
